import _styled from "styled-components";
const _excluded = ["selectedItems", "onClear", "onBlur", "disableClear"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import Footer, { ClearButton, SelectedCount } from '@adsk/alloy-react-footer';
/**
 * pointer-events prevents the menu from closing when clicking disabled clear button.
 * pointer-events disables the not-allowed cursor, so we put it on a parent element.
 */
const disableStyle = {
  parent: {
    cursor: 'not-allowed'
  },
  child: {
    pointerEvents: 'none'
  }
};
export const DefaultFooter = _ref => {
  let {
      selectedItems,
      onClear,
      onBlur,
      disableClear
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Footer, props, selectedItems && /*#__PURE__*/React.createElement(SelectedCount, {
    count: selectedItems.length
  }), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: disableClear ? disableStyle.parent : undefined
  }, /*#__PURE__*/React.createElement(ClearButton, {
    style: disableClear ? disableStyle.child : undefined,
    disabled: disableClear,
    onBlur: onBlur,
    onClick: onClear,
    onMouseDown: e => {
      // Prevent the input from losing focus when the clear button is clicked
      e.preventDefault();
    }
  })));
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "DefaultFooter___StyledDiv",
  componentId: "sc-7xa3ib-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=DefaultFooter.js.map